import React from "react";
import {Link} from "react-router-dom";

import AvatarBlock from "../../../avatar";
import CardMenu from "../../card-menu";
import { HashtagCardMenu } from "../../../hashtag";
import Icons from "../../../icons";


const CardHeroTypeHashtag = (props) => {

    const {
        relation : {
            cover_img,
            slug,
        },
        post
    } = props;


    return (
        <div className="card-hero">
            <AvatarBlock
                photoUrl={cover_img}
                initials={ <Icons.NoImage /> }
                link={`/tag/${slug}`}
                label={`#${slug}`}
                dataClass={'with-link'}
                badgeIcon={ <Icons.Hashtag type="small" /> }
                shape="square"
                avatarAction={
                    <Link to={`/${post.author.nickname}`} className="site-text-color">
                        { post.author.nickname }
                    </Link>
                }
            />
            <CardMenu>
                <HashtagCardMenu { ...props } />
            </CardMenu>
        </div>
    );

};

export default CardHeroTypeHashtag;